"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBug(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0a2.808 2.808 0 012.72 3.508.77.77 0 01-.046.127c.732.424 1.156 1.094 1.156 2.034 0 .265-.046.53-.133.78a.75.75 0 01.271.116c.502.344.965.747 1.383 1.2l.09-.04.1-.03 3.634-.844 1.35-3.31a.766.766 0 011.45.478l-.032.1-1.498 3.677a.766.766 0 01-.435.426l-.101.03-3.555.826c.418.664.76 1.392 1.017 2.165a.756.756 0 01.217-.003l.102.02 3.745 1.022a.766.766 0 01-.3 1.499l-.103-.021-3.262-.89c.095.58.145 1.178.145 1.785 0 .445-.05.895-.143 1.345l2.137.496c.213.05.393.187.497.376l.046.098 1.498 3.95a.766.766 0 01-1.389.638l-.043-.095-1.354-3.569-1.843-.426c-1.402 3.468-4.976 6.531-7.32 6.531-2.346 0-5.92-3.063-7.322-6.531l-1.844.426-1.353 3.569a.766.766 0 01-.888.475l-.1-.03a.766.766 0 01-.474-.889l.03-.1 1.498-3.949a.766.766 0 01.44-.442l.103-.032L4.228 16a6.65 6.65 0 01-.143-1.345c0-.607.05-1.205.145-1.786l-3.262.89a.766.766 0 01-.502-1.443l.099-.034 3.745-1.021a.763.763 0 01.318-.018 9.95 9.95 0 011.017-2.166L2.09 8.253a.766.766 0 01-.49-.362l-.046-.095L.057 4.118a.766.766 0 011.373-.671l.046.093 1.348 3.31 3.636.844c.067.016.13.04.189.071.417-.453.88-.856 1.382-1.199A.764.764 0 018.3 6.45a2.431 2.431 0 01-.128-.781c0-.95.432-1.623 1.177-2.047a.731.731 0 01-.1-.252A2.808 2.808 0 0112 0zm0 4.595c-1.548 0-2.297.393-2.297 1.074 0 .262.12.518.254.6a.766.766 0 11-.796 1.308l-.023-.015a.763.763 0 01-.242.269c-2 1.366-3.279 3.952-3.279 6.824 0 3.58 4.256 7.812 6.383 7.812s6.383-4.233 6.383-7.812c0-2.87-1.28-5.457-3.28-6.825a.763.763 0 01-.247-.28l.013-.005a.766.766 0 01-.925-1.216l.09-.069c.142-.092.264-.345.264-.591 0-.68-.751-1.074-2.298-1.074zm0-3.063c-.706 0-1.277.571-1.277 1.276l.007.13.02.132.011.086a7.728 7.728 0 011.24-.093c.439 0 .85.03 1.23.092l.005-.031A1.276 1.276 0 0012 1.532z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBug;
exports.default = _default;